export default (editor, config = {}) => {
  const bm = editor.BlockManager;
  bm.add('image_media', {
    label: 'Image',
    category: 'Media',
    content: {
      activeOnRender: 1,
      droppable: false,
      resizable: {
        step: 0.2,
        minDim: 3,
        currentUnit: 1,
        autoHeight: true,
      },
      void: true,
      type: 'image_media',
      style: {
        width: '50%',
        height: '50%',
      },
    },
    attributes: {
      class: 'fa fa-image', //icon in the panel
    },
  });
};



// WEBPACK FOOTER //
// ./src/plugins/image/blocks.js